function openCvd() {
    if (window.CVD_SDK) window.CVD_SDK.openWindow();
}
window.openCvd = openCvd;

window.addEventListener('load', function () {
    if (window.CVD_SDK) {
        function setCount() {
            const counts = window.CVD_SDK.getUnreadCount();
            const robotMessage = document.getElementById("robotMessage");
            if (counts > 0) {
                robotMessage.style.display = "block";
                robotMessage.textContent = String(counts >= 99 ? 99 : counts);
            } else {
                robotMessage.style.display = "none";
            }
        }

        setCount();
        window.CVD_SDK.on("unreadCountChange", () => {
            setCount();
        });
    }
});

document.addEventListener("DOMContentLoaded", function () {
    // 聊天入口点击
    document.querySelectorAll(".bottom_right_button_robot_icon").forEach(elem => {
        elem.addEventListener("click", () => {
            if (window.CVD_SDK) {
                window.CVD_SDK.openWindow();
            }
        });
    });
});
